var ModulesCollecrionService = function() {
  this.getModuleCollectionResponseData = function(response) {
    return response;
  };

  this.getModuleCollectionModuleStatusByKey = function(modStatuses, key) {
    return _.find(modStatuses, {module_key: key});
  };

  this.getModuleCollectionUrl = function() {
    return EF.url(`/sdk/enrollments/${EF.enrollment.get('id')}/module_statuses.json`);
  };
};

module.exports = new ModulesCollecrionService();